export const NAV_LINKS = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Capabilities", href: "#services" },
  { label: "Track Record", href: "#experience" },
  { label: "Stack", href: "#stack" },
  { label: "Contact", href: "#contact" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Hardware meets software.",
    body: "Every product begins where silicon meets code. With three decades bridging electronics and firmware, we design systems that treat the boundary between the two as an advantage, not a compromise.",
  },
  {
    no: "02",
    title: "Real-time, or it isn't engineering.",
    body: "Bare-metal, Embedded Linux and FreeRTOS. Deterministic task scheduling, tight power budgets and interrupt-driven architectures — built so timing is a guarantee, never a hope.",
  },
  {
    no: "03",
    title: "From sensor to cloud.",
    body: "We own the full lifecycle: firmware on the microcontroller, cellular and BLE transport, AWS IoT ingestion, serverless processing and the dashboard the operator actually looks at.",
  },
  {
    no: "04",
    title: "Reliable in the field.",
    body: "Aerospace, defence and safety-critical consumer devices demand solutions that simply do not fail. We build maintainable, testable systems designed for the decade ahead — not the demo.",
  },
];

export const SERVICES = [
  {
    id: "embedded-firmware",
    icon: "Cpu",
    title: "Embedded Firmware",
    desc: "Bare-metal & RTOS firmware on ARM, PIC and Silicon Labs MCUs. Low-power, interrupt-driven, production-grade.",
    span: "md:col-span-7",
  },
  {
    id: "system-design",
    icon: "Boxes",
    title: "End-to-End System Design",
    desc: "Architecture spanning sensor, transport, cloud and UI.",
    span: "md:col-span-5",
  },
  {
    id: "realtime",
    icon: "Timer",
    title: "Real-Time Systems",
    desc: "FreeRTOS event-driven design, inter-task queues, deterministic timing.",
    span: "md:col-span-5",
  },
  {
    id: "cloud-iot",
    icon: "CloudCog",
    title: "Cloud & IoT",
    desc: "AWS IoT Core, Lambda and DynamoDB pipelines for structured sensor telemetry over cellular, Wi-Fi & MQTT.",
    span: "md:col-span-7",
  },
  {
    id: "algorithms",
    icon: "Sigma",
    title: "Algorithm Design",
    desc: "Signal conditioning, failure-mode detection and predictive models from large datasets.",
    span: "md:col-span-4",
  },
  {
    id: "test-equipment",
    icon: "TestTubeDiagonal",
    title: "Automated Test & Production Equipment",
    desc: "Function test rigs and automated validation — from bench to production line.",
    span: "md:col-span-8",
  },
  {
    id: "website-creation",
    icon: "Globe",
    title: "Website & Web Platform Creation",
    desc: "Full-stack websites and web platforms — from marketing sites to real-time, multi-tenant IoT dashboards with device registries, live telemetry and predictive AI.",
    span: "md:col-span-12",
    example: { label: "quantzillion.com", href: "https://www.quantzillion.com" },
  },
];

export const EXPERIENCE = [
  {
    era: "2019 — Present",
    role: "Embedded Firmware Engineer",
    org: "Independent · Contracting (Figfi)",
    industry: "IoT / Air Quality / Gas Detection",
    points: [
      "Air-quality monitor on Silicon Labs ARM + Telit 4G streaming JSON to AWS IoT Core, Lambda & DynamoDB.",
      "Wi-Fi metal-detection system with RESTful control and FreeRTOS event architecture.",
      "Handheld gas-pressure & leak detector with MEMS sensors, SPI logging and a BLE companion app.",
    ],
    image: "iot",
  },
  {
    era: "2012 — 2019",
    role: "Senior Firmware Design Engineer",
    org: "FireAngel Safety Technology",
    industry: "Safety-Critical Consumer Electronics",
    points: [
      "Firmware in C for PIC16F across smoke, CO and heat alarms — analogue conditioning, SPI, PWM, battery & low-power.",
      "Variance-based failure-mode detection algorithm for electrochemical gas sensors from large datasets.",
      "Predictive risk model for cloud-connected alarm fleets enabling proactive monitoring.",
    ],
    image: "medical",
  },
  {
    era: "Earlier",
    role: "Systems & Software Design Engineer",
    org: "Smiths Industries · Global-Invacom · Triteq · Tekhne",
    industry: "Aerospace & Defence",
    points: [
      "Ultrasonic fuel-gauging systems for the Boeing B777 programme.",
      "Data-acquisition system deployed on the Challenger 2 main battle tank.",
      "High-volume satellite-TV electronics and industrial control systems.",
    ],
    image: "aerospace",
  },
];

export const TECH_STACK = [
  "C", "C#", "Python", "Dart", "Embedded Linux", "FreeRTOS", "ARM M0+",
  "PIC", "BLE", "MQTT", "AWS IoT Core", "Lambda", "DynamoDB",
  "I2C", "SPI", "UART", "RS232", "GNSS", "Cellular", "Sub-GHz", "Flutter",
];

export const STATS = [
  { value: "30+", label: "Years engineering" },
  { value: "8", label: "Industries shipped" },
  { value: "B777", label: "Avionics heritage" },
  { value: "IoT→Cloud", label: "Full stack ownership" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1767549707419-ceef47ff370d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjaXJjdWl0JTIwYm9hcmQlMjBlbGVjdHJvbmljcyUyMG1hY3JvJTIwZGFya3xlbnwwfHx8fDE3ODUyNzUyMDd8MA&ixlib=rb-4.1.0&q=85",
  aerospace: "https://images.unsplash.com/photo-1520442027413-7bf6c51517da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxhZXJvc3BhY2UlMjBlbmdpbmVlcmluZyUyMGRhcmslMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4NTI3NTIwN3ww&ixlib=rb-4.1.0&q=85",
  circuit: "https://images.unsplash.com/photo-1773615098146-2341d1b72997?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjaXJjdWl0JTIwYm9hcmQlMjBlbGVjdHJvbmljcyUyMG1hY3JvJTIwZGFya3xlbnwwfHx8fDE3ODUyNzUyMDd8MA&ixlib=rb-4.1.0&q=85",
  medical: "https://images.unsplash.com/photo-1576400883215-7083980b6193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwdGVjaG5vbG9neSUyMGVsZWN0cm9uaWNzJTIwZGFya3xlbnwwfHx8fDE3ODUyNzUyMTl8MA&ixlib=rb-4.1.0&q=85",
  iot: "https://images.unsplash.com/photo-1584761650834-efc7932b9c4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxJb1QlMjBjb25uZWN0ZWQlMjBkZXZpY2VzJTIwZGFyayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg1Mjc1MjIwfDA&ixlib=rb-4.1.0&q=85",
};
